import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SocialIcons, BUSINESS_EMAIL } from "./Contact";

export const Footer = () => (
  <footer className="bg-[#0B0B0B] text-white px-5 sm:px-10 lg:px-16 pt-20 pb-10" data-testid="site-footer">
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12">
      <div>
        <Logo tone="light" />
        <p className="font-display uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.9] mt-10">
          Party <span className="text-[#E10600]">Lyfe</span>
          <br />Forever.
        </p>
        <SocialIcons prefix="footer" className="mt-8" />
        <a href={`mailto:${BUSINESS_EMAIL}`} data-testid="footer-email-link" className="inline-block mt-4 font-semibold text-zinc-200 transition-colors duration-200 hover:text-[#E10600]">{BUSINESS_EMAIL}</a>
      </div>
      <nav className="flex flex-col gap-3 font-mono-x uppercase text-sm tracking-[0.2em]">
        <Link to="/shop" data-testid="footer-link-shop" className="transition-colors duration-200 hover:text-[#E10600]">Shop the Hat</Link>
        <Link to="/coming-soon" data-testid="footer-link-coming-soon" className="transition-colors duration-200 hover:text-[#E10600]">Next Drop</Link>
        <Link to="/contact" data-testid="footer-link-contact" className="transition-colors duration-200 hover:text-[#E10600]">Contact</Link>
        <Link to="/shipping" data-testid="footer-link-shipping" className="transition-colors duration-200 hover:text-[#E10600]">Shipping & Returns</Link>
        <Link to="/admin" data-testid="footer-link-admin" className="transition-colors duration-200 hover:text-[#E10600]">X Check In</Link>
      </nav>
    </div>
    <div className="mt-16 pt-6 border-t border-white/20 flex flex-col sm:flex-row justify-between gap-3 font-mono-x text-xs uppercase tracking-[0.2em] text-zinc-300">
      <span>© {new Date().getFullYear()} X-SQUAD</span>
      <span>Secure checkout · Visa · Mastercard · Apple Pay · Cash App Pay · Free US shipping</span>
    </div>
  </footer>
);
